import React from 'react';
import { Form, Input, Select } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { t } from 'i18next';
import { useMeasurement } from '@/hooks/useMeasurement';
import { PlatformOptions } from '@/store/SiteSurveyForm/constants';
import { SpecModeFormProps } from './AdditionalInformationModal.utils';

const SpecModeForm: React.FC<SpecModeFormProps> = ({ fieldNamePath, onPressureChange }) => {
  const { tunit } = useMeasurement();

  return (
    <div className="form-section">
      <Form.Item
        name={[...fieldNamePath, 'specUrl']}
        label={<span>{t('URL to compressor model spec')}</span>}
        validateTrigger={['onChange', 'onBlur']}
        rules={[
          {
            type: 'url',
            message: t('Please enter a valid URL'),
          },
        ]}
        layout="vertical"
      >
        <Input type="url" placeholder={t('Paste link to spec')} suffix={<LinkOutlined />} size="large" />
      </Form.Item>

      <div className="platform-pressure-row">
        <div className="platform-field">
          <Form.Item name={[...fieldNamePath, 'platform']} label={<span>{t('Platform')}</span>} layout="vertical">
            <Select
              placeholder={t('Select')}
              size="large"
              options={Object.values(PlatformOptions).map(value => ({
                label: value,
                value: value,
              }))}
            />
          </Form.Item>
        </div>

        <div className="pressure-field">
          <Form.Item name={[...fieldNamePath, 'pressure']} label={<span>{t('Pressure')}</span>} layout="vertical">
            <Input
              placeholder={t('Enter value')}
              suffix={<span>{tunit('bar')}</span>}
              size="large"
              onChange={e => onPressureChange(e.target.value, [...fieldNamePath, 'pressure'])}
            />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default SpecModeForm;
